import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

const Services = () => {
  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Our Services</h1>
          <p>Comprehensive Construction & Design Solutions</p>
        </div>
      </section>

      {/* Services Content */}
      <section className="services-content">
        <div className="container">
          <div className="intro-text">
            <h2>What We Offer</h2>
            <p>
              At Bricks & Brain, we provide end-to-end construction and design services tailored to meet your 
              specific needs. From concept to completion, our expert team ensures quality, innovation, and timely delivery.
            </p>
          </div>

          {/* Services Grid */}
          <div className="services-grid">
            {/* Service 1 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">🏠</div>
              </div>
              <div className="service-content">
                <h3>Residential Construction</h3>
                <p>
                  Custom home building services from foundation to finishing. We create dream homes tailored 
                  to your lifestyle, incorporating modern amenities and energy-efficient designs.
                </p>
                <ul className="service-features">
                  <li>Custom home design</li>
                  <li>Foundation to finishing</li>
                  <li>Modern amenities integration</li>
                  <li>Energy-efficient solutions</li>
                </ul>
              </div>
            </div>

            {/* Service 2 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">🏢</div>
              </div>
              <div className="service-content">
                <h3>Commercial Construction</h3>
                <p>
                  Professional construction solutions for offices, retail spaces, and commercial complexes. 
                  We deliver functional, aesthetically pleasing spaces that enhance business productivity.
                </p>
                <ul className="service-features">
                  <li>Office buildings</li>
                  <li>Retail spaces</li>
                  <li>Commercial complexes</li>
                  <li>Industrial facilities</li>
                </ul>
              </div>
            </div>

            {/* Service 3 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">🎨</div>
              </div>
              <div className="service-content">
                <h3>Renovation & Remodeling</h3>
                <p>
                  Transform existing spaces with our comprehensive renovation services. From minor updates 
                  to complete overhauls, we breathe new life into old structures.
                </p>
                <ul className="service-features">
                  <li>Space transformation</li>
                  <li>Complete overhauls</li>
                  <li>Modernization projects</li>
                  <li>Heritage restoration</li>
                </ul>
              </div>
            </div>

            {/* Service 4 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">🛋️</div>
              </div>
              <div className="service-content">
                <h3>Interior & Exterior Works</h3>
                <p>
                  Complete interior design and exterior finishing services. We handle everything from 
                  flooring and false ceilings to facades and landscaping with attention to detail.
                </p>
                <ul className="service-features">
                  <li>Interior design & decoration</li>
                  <li>Flooring solutions</li>
                  <li>Facade design</li>
                  <li>Landscaping</li>
                </ul>
              </div>
            </div>

            {/* Service 5 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">📋</div>
              </div>
              <div className="service-content">
                <h3>Project Management</h3>
                <p>
                  End-to-end project management ensuring timely delivery and budget compliance. Our expert 
                  team coordinates all aspects of construction for seamless execution.
                </p>
                <ul className="service-features">
                  <li>Timeline management</li>
                  <li>Budget control</li>
                  <li>Quality assurance</li>
                  <li>Vendor coordination</li>
                </ul>
              </div>
            </div>

            {/* Service 6 */}
            <div className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">📐</div>
              </div>
              <div className="service-content">
                <h3>Structural Design & Planning</h3>
                <p>
                  Innovative architectural design and structural engineering services. We create blueprints 
                  that balance aesthetics, functionality, and structural integrity.
                </p>
                <ul className="service-features">
                  <li>Architectural design</li>
                  <li>Structural engineering</li>
                  <li>3D visualization</li>
                  <li>Building permits</li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="services-cta">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can bring your vision to life</p>
            <Link to="/contact" className="btn-cta">Get a Free Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
